<script setup>
import {useEnv} from '@/composables/use-env.js'
import {useTeams} from '@/composables/use-teams.js'

//Get hash
const {gitHash} = useEnv()
const {isInTeams, teamsAppId, teamsAppVersion} = useTeams()
</script>

<template>
  <p>
    <small text-muted>
      App version: {{ gitHash }}
      <template v-if="isInTeams">
        <br>Teams app ID: {{ teamsAppId || 'n/a' }}
        <br>Teams app version: {{ teamsAppVersion || 'n/a' }}
      </template>
    </small>
  </p>
</template>
